<div class="cerrix-form-field" [class.errors]="ngControl?.touched && ngControl?.invalid">
    <cerrix-datepicker
        [minDate]="minDate"
        [maxDate]="maxDate"
        [placeholder]="placeholder"
        [formControl]="dateFormControl"
        [dataUiid]="dataUiid"
        (ngModelChange)="onDateTimeChange()"
    >
    </cerrix-datepicker>

    <div class="cerrix-time-form-field">
        <mat-form-field subscriptSizing="dynamic">
            <input
                class="cerrix-time-input"
                matInput
                type="text"
                placeholder="00"
                maxlength="2"
                [formControl]="hoursFormControl"
                [errorStateMatcher]="errorMatcher"
                (change)="onDateTimeChange()"
                numbersOnly
                addLeadingZero
                [minimalStringLength]="2"
                [attr.data-uiid]="dataUiid + 'hour-input'"
            />
        </mat-form-field>
        <span class="cerrix-time-divider"> : </span>
        <mat-form-field subscriptSizing="dynamic">
            <input
                class="cerrix-time-input"
                matInput
                type="text"
                placeholder="00"
                maxlength="2"
                [formControl]="minutesFormControl"
                [errorStateMatcher]="errorMatcher"
                (change)="onDateTimeChange()"
                numbersOnly
                addLeadingZero
                [minimalStringLength]="2"
                [attr.data-uiid]="dataUiid + 'minute-input'"
            />
        </mat-form-field>
    </div>
</div>

<div class="cerrix-form-field-error-wrapper">
    @if (hoursFormControl.touched) {
        @for (error of hoursFormControl.errors | errorMessages; track error) {
            <mat-error class="form-field-error">{{ error }}</mat-error>
        }
    }
    @if (minutesFormControl.touched) {
        @for (error of minutesFormControl.errors | errorMessages; track error) {
            <mat-error class="form-field-error">{{ error }}</mat-error>
        }
    }

    @if (
        dateFormControl.touched &&
        ((minDate && ngControl?.value < minDate) || (maxDate && ngControl?.value > maxDate))
    ) {
        <mat-error class="form-field-error"
            >Date should be between {{ minDate | cerrixDate: true }} and
            {{ maxDate | cerrixDate: true }}
        </mat-error>
    }

    @if (
        ngControl?.touched &&
        ngControl?.invalid &&
        dateFormControl.errors === null &&
        hoursFormControl.errors === null &&
        minutesFormControl.errors === null
    ) {
        @for (error of ngControl?.control?.errors | errorMessages; track error) {
            <mat-error>{{ error }}</mat-error>
        }
    }
</div>
